import React from "react";
import Logo from "../../assets/amal-logo-navy.png";
import FilterIcon from "../../assets/slider.png";
import AddIcon from "../../assets/add.png";
import qrIcon from "../../assets/qr-scan.png";
import dispatchIcon from "../../assets/dispatch.png";
import locIcon from "../../assets/location.png";


// import Logo from "../assets/amal-logo-2.png";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import LogoMobile from "../../assets/fav.png"
import { useNavigate } from "react-router-dom";

export function Header({
  showSwatchDetails,
  setFilterOpen,
  totalFilterCount,
  setEnableSelection,
  enableSelection,
  setScanning,
  updateState,
  search,
  onSubmit,
  token
}) {
  const navigate = useNavigate()
  const handelSubmit = (e) => {
      e.preventDefault()
      onSubmit()
      // setSearch({text})
  }

  const toHomePage = () => {
    navigate("/Home")
  }

  return (
    <header className="header">
      <div onClick={toHomePage}>
        <img alt="Amal Logo" src={Logo} className="header-logo" />
        <img alt="Amal Logo" src={LogoMobile} className="header-logo-mobile" />

      </div>
      <div className="header-icons-wrapper">
        {
        !showSwatchDetails 
        ? <div className="search-bar-mobile">
                <Paper
                    component="form"
                    onSubmit={handelSubmit}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: {
                        xs: "100px",
                        sm: "160px",
                        md: "200px"
                      },
                      padding: {
                        xs: "0px 0px",
                        sm: "0px 0px",
                      },
                      marginRight: "3px",
                      borderWidth: "0 0 1px 0" ,
                      margin: "0 auto",
                      borderStyle: "solid",
                      borderColor: "#c3c3c3",
                      borderRadius: 0,
                      boxShadow: "none",
                    }}
                  >
                    <InputBase
                      value={search}
                      onChange={e => updateState({ "Search": e.target.value })}
                      sx={{ px: 0.5,  flex: 1, fontSize: {xs: "1.3rem" , sm: "1.5rem"}  }}
                      placeholder="Amal Code"
                      inputProps={{ "aria-label": "search header" }}
                    />
                    {/* <IconButton type="submit" sx={{ p: "2px", marginLeft: { xs:"1px" ,sm:"2px"} }} aria-label="search">
                      <img alt="search" className="search-icon-header"  src={magnifyImage} />
                    </IconButton> */}
                  </Paper>
                </div>
        : null
        }
        {!showSwatchDetails ? (
          <div
            onClick={() => setFilterOpen(true)}
            className="header-icon-container filter-image"
          >
            {totalFilterCount ? (
              <div className="filter-total-count">{totalFilterCount}</div>
            ) : (
              ""
            )}
            <img alt="Filter icon" src={FilterIcon} />
          </div>
        ) : null}
        <div className="header-icon-container">
          <img
            alt="QR code scanner icon"
            onClick={() => {
              setScanning(true);
            }}
            src={qrIcon}
          />
        </div>
        <a 
          className="header-icon-container"
          href={"https://form.simplifii.site/add_dispatch?base=amal&token=" + token}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            alt="Dispatch Icon"
            src={dispatchIcon}
          />
        </a>
        <a 
          className="header-icon-container"
          href={"https://form.simplifii.site/set_location?base=amal&token=" + token}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            alt="Set Location of Swatches"
            src={locIcon}
          />
        </a>
        {!showSwatchDetails ? (
          <div
            onClick={() => setEnableSelection(!enableSelection)}
            className={`header-icon-container ${
              enableSelection ? "active" : ""
            }`}
          >
            <img alt="Add to Collection icon" src={AddIcon} />
          </div>
        ) : null}
      </div>
    </header>
  );
}
